/* eslint-disable prettier/prettier */
import axios, { AxiosError } from 'axios';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 0,  
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error: AxiosError) => {
    if (error.response) return Promise.reject(error);

    const enriched: any = new Error(
      'Network error: request was blocked or timed out before any response.'
    );
    enriched.code = (error as any).code || 'NETWORK_NO_RESPONSE';
    enriched.details = (error as any).toJSON ? (error as any).toJSON() : { message: error.message };
    return Promise.reject(enriched);
  }
);